<template>
	<div>
		<h1 class="view-title" data-v-step-tracking="1">
			RASTREIO <span v-popover:tooltip.right="'Seção de acompanhamento das rotas de entrega'"><i class="fas fa-question-circle"></i></span>
			<button class="btn btn-link btn-right" @click="$refs.tour.editTour()" data-v-step-tracking="2">
				<i class="fas fa-question-circle"></i> TOUR
			</button>
		</h1>
		<div class="filter-container" data-v-step-tracking="3">
			<button class="map-filter-item-all shadowed" @click="filter('all')" :class="{ 'active' : (current_filter == 'all') }">
				TODOS
			</button>
			<button class="map-filter-item shadowed" @click="filter('no_delivery')" :class="{ 'active' : (current_filter == 'no_delivery') }">
				<img :src="require('@/assets/gray_light_marker3.svg')" height="20" width="20" /> NENHUMA ENTREGA
			</button>
			<button class="map-filter-item shadowed" @click="filter('waiting')" :class="{ 'active' : (current_filter == 'waiting') }">
				<img :src="require('@/assets/gray_marker2.svg')" height="20" width="20" /> AGUARDANDO
			</button>
			<button class="map-filter-item shadowed" @click="filter('in_progress')" :class="{ 'active' : (current_filter == 'in_progress') }">
				<img :src="require('@/assets/blue_marker2.svg')" height="20" width="20" /> A CAMINHO
			</button>
			<button class="map-filter-item shadowed" @click="filter('check_in')" :class="{ 'active' : (current_filter == 'check_in') }">
				<img :src="require('@/assets/yellow_marker2.svg')" height="20" width="20" /> ENTREGANDO
			</button>
			<button class="map-filter-item shadowed" @click="filter('finished')" :class="{ 'active' : (current_filter == 'finished') }">
				<img :src="require('@/assets/green_marker2.svg')" height="20" width="20" /> FINALIZADO
			</button>
			<button class="map-filter-item shadowed" @click="filter('failed')" :class="{ 'active' : (current_filter == 'failed') }">
				<img :src="require('@/assets/red_marker2.svg')" height="20" width="20" /> NÃO ENTREGUE
			</button>
		</div>
		<div class="inner-content shadowed">
			<div v-show="loading">
				<div class="loading shadowed">
					<i class="fa fa-circle-notch fa-spin"></i>
				</div>
			</div>
			<div v-show="!loading" class="search" data-v-step-tracking="5">
				<div class="label-search-div">
					<label>Filtrar <span v-popover:tooltip.right="'Selecione motorista vinculado que deseja acompanhar'"><i class="fas fa-question-circle"></i></span>: </label>
					<select v-model="selected_driver" @change="setMarker">
						<option :value="0">Todos</option>
						<option v-for="driver in driver_options" :value="driver.id" :key="driver.id">
							{{ driver.driver_name + " (" + driver.nickname + ")" }}
						</option>
					</select>
				</div>
				<div class="label-switch-div">
					<label class="label-switch" :class="follow_current_driver ? 'label-switch-on' : 'label-switch-off'" @change="verifySwitch">
						<!-- Input -->
						<input type="checkbox" class="label-switch__input" v-model="follow_current_driver" />
						<!-- Circle -->
						<div class="label-switch__circle"></div>
						<!-- Text -->
						<label class="label-switch__text">Monitorar motorista <span v-popover:tooltip.left="'Ative para acompanhar o motorista selecionado em tempo real'"><i class="fas fa-question-circle"></i></span></label>
					</label>
				</div>
			</div>
			<TrackingInfo v-if="show_current_driver_info" :current="current_driver" @openMap="openMap" @close="closeInfo" />
			<div v-show="!loading" class="map shadowed" ref="map" data-v-step-tracking="4"></div>
		</div>
		<TrackingRoute v-if="show_current_driver_route_map" :current="current_driver" @close="closeMap" />
		
		<Tour
            tour="Tracking"
            :steps="tour_steps"
			:callbackOnFinish="true"
			ref="tour"
        />
	</div>
</template>

<script>
import Api from "@/lib/Api";

import GoogleMapsApiLoader from 'google-maps-api-loader';
import Tour from "@/components/Tour";
import TrackingInfo from "./Tracking/TrackingInfo";
import TrackingRoute from "./Tracking/TrackingRoute";

const status = {
	no_delivery: {
		url: require("@/assets/gray_light_marker3.svg"),
		color: "#aaa",
		status: "Nenhuma entrega",
	},
	waiting: {
		url: require("@/assets/gray_marker2.svg"),
		color: "#555",
		status: "Aguardando",
	},
	in_progress: {
		url: require("@/assets/blue_marker2.svg"),
		color: "#005ef7",
		status: "A caminho",
	},
	check_in: {
		url: require("@/assets/yellow_marker2.svg"),
		color: "#ffb300",
		status: "Entregando",
	},
	finished: {
		url: require("@/assets/green_marker2.svg"),
		color: "#008000",
		status: "Finalizado",
	},
	failed: {
		url: require("@/assets/red_marker2.svg"),
		color: "#ff0000",
		status: "Não entregue",
	},
	untracked: {
		url: require("@/assets/gray_light_marker2.svg"),
		color: "#eee",
		status: "Desvinculado",
	},
};

export default {
	name: 'Tracking',
	
	components: {
		Tour,
		TrackingInfo,
		TrackingRoute,
	},

	data() {
		let center = false;
		try {
			let cache = JSON.parse(localStorage.getItem('Tracking.location'));
			if (cache.address == this.$api.user.company_address) {
				center = cache.coordinates;
			}
		} catch(e) {
			center = false;
		}

		return {
			loading: false,

			google: null,
            map: null,
			center: center,
			zoom: 13,
            markers: [],
            geocoder: null,

			list: [],
			current_filter: 'all',

			current_driver: null,
			show_current_driver_info: false,
			show_current_driver_route_map: false,

			driver_options: [],
			selected_driver: 0,

			follow_current_driver: false,
			
            tour_steps: [
                {
                    target: '[data-v-step-tracking="0"]',
                    header: {
                        title: '<code>SEÇÃO RASTREIO</code>',
                    },
                    content: '<code>Clique no menu <b>RASTREIO</b> para ir a seção acompanhamento das motoristas e cargas em tempo real</code>',
                    params: {
                        placement: 'right',
                        highlight: false,
                    }
                },
                {
                    target: '[data-v-step-tracking="1"]',
                    header: {
                        title: '<code>SEÇÃO ATUAL</code>',
                    },
                    content: '<code>Identifique pelo título a seção que está atualmente</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-tracking="2"]',
                    header: {
                        title: '<code>TOUR</code>',
                    },
                    content: '<code>Em caso de dúvida clique no botão <b>TOUR</b> para gerenciar a exibição do tour nessa seção, e assim ter um auxílio referente aos elementos da página</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
				{
                    target: '[data-v-step-tracking="3"]',
                    header: {
                        title: '<code>ABAS DE STATUS</code>',
                    },
                    content: '<code>Clique nas <b>ABAS DE STATUS</b> para filtrar rapidamente a exibição dos motoristas no mapa por seu status atual</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-tracking="4"]',
                    header: {
                        title: '<code>MAPA DE RASTREIO</code>',
                    },
                    content: '<code>Clique em <b>MAPA DE RASTREIO</b> para iniciar o processamento e avançar para a etapa visualização</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
				{
                    target: '[data-v-step-tracking="5"]',
                    header: {
                        title: '<code>FILTRO DE MOORISTA</code>',
                    },
                    content: '<code>Clique em <b>FILTRO DE MOORISTA</b> para iniciar o processamento e avançar para a etapa visualização</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
            ],
		}
	},

	beforeCreate: function() {
		if (!this.$permission.hasAreaPermission("Tracking")) {
            this.$router.push({ name: 'Home' });
        }
	},

	mounted: async function() {
		// Requisita as informações necessárias
		this.loading = true;
		this.$refs.tour.setTour();
		await this.load();

        // Inicia o mapa
        this.start();
		this.loading = false;
		
		// Atualiza busca as posições novamente
		this.interval = setInterval(() => {
			this.update();
		}, 30000);
    },

	destroyed: function() {
		clearInterval(this.interval);
	},

	methods: {
		// Busca as posições e registros
		load: async function() {
			// Faz a requisição
			let result = null;
			try {
				result = await Api.post("tracking/get-positions");
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter as localizações dos motoristas.");
				return;
			}

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.list = result.data;
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter a lista.");
				return;
			}
		},

		// Inicia os métodos
        start: async function() {
            // Carrega a API do Google Map
            this.google = await GoogleMapsApiLoader({
                apiKey: this.$api.config.B2B_GOOLE_API_KEY
            });
            
            // Inicia o mapa
			if (this.center !== false) {
				// Inicia o mapa
				this.initializeMap();
			} else {
				// Inicia o geocoder
				this.geocoder = new this.google.maps.Geocoder();
				
				// Busca a posição do endeço
				await this.geocoder.geocode({
					"address": this.$api.user.company_address
				}, (results) => {
					let coordinates = {
						lat: results[0].geometry.location.lat(),
						lng: results[0].geometry.location.lng(),
					};

					localStorage.setItem('Tracking.location', JSON.stringify({
						address: this.$api.user.company_address,
						coordinates: coordinates
					}));

					this.center = coordinates;	
				});

				// Inicia o mapa
				this.initializeMap();
			}

			// Adiciona os marcadores
			this.createMarkers();
        },

		/**
		 * Gera o mapa
		 **/
        initializeMap: function() {
            // Cria o mapa
			this.map = new this.google.maps.Map(this.$refs.map, {
				backgroundColor: "#fff",
				center: this.center,
				zoom: this.zoom,
				zoomControl: true,
				zoomControlOptions: {
					position: this.google.maps.ControlPosition.RIGHT_BOTTOM,
				},
				streetViewControl: false,
				mapTypeControl: false,
				fullscreenControl: false,
				styles: [
					/*{
						featureType: "poi",
						stylers: [{
							visibility: "off",
						}],
					},*/{
						featureType: "transit",
						elementType: "labels.icon",
						stylers: [{
							visibility: "off",
						}],
					}
				],
			});
        },

		/**
		 * Adiciona o marcador de endereço
		 **/
        createMarkers: function() {
			this.list.forEach((driver, index) => {
				if (driver.location != null) {
					// Separa as coordenadas
					let coordinates = driver.location.split(",");

					// Determina o marcador da posição do APP e coloca no mapa
					let marker = new this.google.maps.Marker({
						map: this.map,
						position: {
							lat: parseFloat(coordinates[0]),
							lng: parseFloat(coordinates[1])
						},
						icon: {
							url: status[driver.current_status].url,
							size: new this.google.maps.Size(40, 40),
							scaledSize: new this.google.maps.Size(40, 40),
							origin: new this.google.maps.Point(0, 0),
							anchor: new this.google.maps.Point(20, 40),
							labelOrigin: new this.google.maps.Point(20, 50),
							draggable: false,
						},
						//title: driver.nickname ? driver.nickname : driver.driver_name.split(" ")[0],
						label: {
							text: driver.nickname ? driver.nickname : driver.driver_name.split(" ")[0],
							fontWeight: "bold",
							color: status[driver.current_status].color,
							className: "marker-label",
						},
						zIndex: index,
					});

					// Obtém o endereço atual
					//let currentAddress = await this.getCurrentAddress(marker.getPosition());
					
					// Define as informações que aparecerão no popup
					let infowindow = new this.google.maps.InfoWindow({
						content:
							'<div class="popup">' +
								'<h3 class="capitalized">' + driver.driver_name.toLowerCase() + ' (' + driver.nickname.toLowerCase() + ')</h3>' +
								'<h4><b><span style="color: ' + status[driver.current_status].color + '"><i class="fa fa-circle"></i></span> ' + status[driver.current_status].status + '</b></h4>' +
								'<p class="marker"><b><i class="fa fa-fw fa-id-card"></i> Identificação:</b> ' + driver.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") + '</p>' +
								'<p class="marker"><b><i class="fa fa-fw fa-phone fa-rotate-90"></i> Telefone:</b> ' + (driver.phone ? driver.phone.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4") : "Não definido") + '</p>' +
								'<p class="marker"><b><i class="fa fa-fw fa-truck"></i> Veículo' + (driver.current_total_opened == 0 ? ' mais recente' : '') + ':</b> ' + (driver.current_license_plate ? driver.current_license_plate : 'Não definido') + '</p>' +
								'<p class="marker"><b><i class="fa fa-fw fa-boxes"></i> Carga' + (driver.current_total_opened == 0 ? ' mais recente' : '') + ':</b> ' + (driver.current_cargo ? driver.current_cargo : 'Não definida') + '</p>' +
								'<p class="marker"><b><i class="fa fa-fw fa-box"></i> Entrega' + (driver.current_total_opened == 0 ? ' mais recente' : '') + ':</b> ' + (driver.current_delivery ? driver.current_delivery : "Não definida") + '</p>' +
								//'<p class="marker"><b>Local atual:</b> ' + currentAddress.formatted_address + '</p>' +
								'<p class="marker"><b><i class="fa fa-fw fa-sync"></i> Última atualização:</b> ' + this.getFormattedDate(driver.updated_at) + '</p>' +
							'</div>',
						pixelOffet: new this.google.maps.Point(0, 0),
					});
					
					// abre o popup ao passar o mouse por cima do marcador
					this.google.maps.event.addListener(marker, "mouseover", function() {
						infowindow.open(this.map, marker);
					});
					
					// Fecha o popup ao retirar o mouse de cima do marcador
					this.google.maps.event.addListener(marker, "mouseout", function() {
						infowindow.close(this.map, marker);
					});
					
					// Abre o modal de informação do motorista
					marker.addListener("click", () => {
						this.openInfo(driver);
					});

					// Adiciona a lista de marcadores
					this.markers.push({
						id: driver.id,
						marker: marker
					});
				}

				// Adiciona a lista de options
				this.driver_options.push(driver);
			});

			// Atualiza Dom
			this.$forceUpdate();
        },

		/**
		 * Filtra os marcadores no mapa
		 * */
		filter: function(status) {
			// Atualiza o stus atual
			if (status) this.current_filter = status;

			// Reinicia o select
			this.selected_driver = 0;
			
			// Reinicia o flag de seguir
			this.follow_current_driver = false;

			// Limpa os marcadores
			this.clean();

			// Fecha o card
			this.closeInfo();

			// Adiciona marcadores ao mapa
			this.updateMarkers();
		},

		/**
		 * Atualiza as posições dos marcadores
		 */
		update: async function() {
			// Requisia as informações
			await this.load();

			// Apaga os marcadores do mapa
			this.clean();
			
			// Adiciona marcadores ao mapa
			this.updateMarkers();
		},

		/**
		 * Limpa os marcadores do mapa
		 */
		clean: function() {
			this.markers.forEach(element => {
				element.marker.setVisible(false);
				this.google.maps.event.clearInstanceListeners(element.marker);
			});
			this.driver_options = [];
		},

		/**
		 * Atualiza os marcadores de endereço
		 **/
        updateMarkers: function() {
			// Percorre a lista de registros retornados pela API
			this.list.forEach((driver, index) => {
				// Verifica se o registro atual faz parte do filtro
				if (((this.current_filter == "all") && (driver.location != null)) || ((this.current_filter == driver.current_status) && (driver.location != null))) {
					// Filtra o marcador
					let element = null;
					element = this.markers.filter(element => element.id == driver.id);
					
					// Verifica se foi encontrado o marcador
					if (element.length > 0) {
						// Obtem o objeto do carcador do registros atual
						let id = element[0].id;
						let marker = element[0].marker;

						// Atualiza a cor do marcador
						marker.setIcon({
							url: status[driver.current_status].url,
							size: new this.google.maps.Size(40, 40),
							scaledSize: new this.google.maps.Size(40, 40),
							origin: new this.google.maps.Point(0, 0),
							anchor: new this.google.maps.Point(20, 40),
							labelOrigin: new this.google.maps.Point(20, 50),
							draggable: false,
						});
						
						// Atualiza a cor do texto
						marker.setLabel({
							text: driver.nickname ? driver.nickname : driver.driver_name.split(" ")[0],
							fontWeight: "bold",
							color: status[driver.current_status].color,
							className: "marker-label",
						});

						// Obtém o endereço atual
						//let currentAddress = await this.getCurrentAddress(marker.getPosition());
						
						// Define as informações que aparecerão no popup
						let infowindow = new this.google.maps.InfoWindow({
							content:
								'<div class="popup">' +
									'<h3 class="capitalized">' + driver.driver_name.toLowerCase() + ' (' + driver.nickname.toLowerCase() + ')</h3>' +
									'<h4><b><span style="color: ' + status[driver.current_status].color + '"><i class="fa fa-circle"></i></span> ' + status[driver.current_status].status + '</b></h4>' +
									'<p class="marker"><b><i class="fa fa-fw fa-id-card"></i> Identificação:</b> ' + driver.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-phone fa-rotate-90"></i> Telefone:</b> ' + (driver.phone ? driver.phone.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4") : "Não definido") + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-circle"></i> Situação:</b> ' + status[driver.current_status].status + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-truck"></i> Veículo' + (driver.current_total_opened == 0 ? ' mais recente' : '') + ':</b> ' + (driver.current_license_plate ? driver.current_license_plate : 'Não definido') + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-boxes"></i> Carga' + (driver.current_total_opened == 0 ? ' mais recente' : '') + ':</b> ' + (driver.current_cargo ? driver.current_cargo : 'Não definida') + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-box"></i> Entrega' + (driver.current_total_opened == 0 ? ' mais recente' : '') + ':</b> ' + (driver.current_delivery ? driver.current_delivery : "Não definida") + '</p>' +
									//'<p class="marker"><b>Local atual:</b> ' + currentAddress.formatted_address + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-sync"></i> Última atualização:</b> ' + this.getFormattedDate(driver.updated_at) + '</p>' +
								'</div>',
							pixelOffet: new this.google.maps.Point(0, 0),
						});
						
						// abre o popup ao passar o mouse por cima do marcador
						this.google.maps.event.addListener(marker, "mouseover", function() {
							infowindow.open(this.map, marker);
						});
						
						// Fecha o popup ao retirar o mouse de cima do marcador
						this.google.maps.event.addListener(marker, "mouseout", function() {
							infowindow.close(this.map, marker);
						});
						
						// Abre o modal de informação do motorista
						marker.addListener("click", () => {
							this.openInfo(driver);
						});

						// O torna visível no mapa
						marker.setVisible(true);
						
						// Separa as coordenadas
						let coordinates = driver.location.split(",");
						
						// Obtém as posições
						let currentPosition = marker.getPosition();
						let newPosition = new this.google.maps.LatLng(coordinates[0], coordinates[1]);
						
						// Verifica se a posições atual é diferente
						if ((currentPosition.lat() != newPosition.lat()) || (currentPosition.lng() != newPosition.lng())) {
							// Atualiza a posição do marcador
							//marker.setPosition(newPosition);
							this.animateReposition(id, marker, currentPosition, newPosition, .5);
						}
						
						// Posiciona o mapa no motorista
						if ((this.current_driver != null) && (this.current_driver.id == driver.id)) {
							// Atualiza a instância do motorista atual
							this.current_driver = driver;
						}
					} else {
						// Separa as coordenadas
						let coordinates = driver.location.split(",");

						// Determina o marcador da posição do APP e coloca no mapa
						let marker = new this.google.maps.Marker({
							map: this.map,
							position: {
								lat: parseFloat(coordinates[0]),
								lng: parseFloat(coordinates[1])
							},
							icon: {
								url: status[driver.current_status].url,
								size: new this.google.maps.Size(40, 40),
								scaledSize: new this.google.maps.Size(40, 40),
								origin: new this.google.maps.Point(0, 0),
								anchor: new this.google.maps.Point(20, 40),
								labelOrigin: new this.google.maps.Point(20, 50),
								draggable: false,
							},
							//title: driver.nickname ? driver.nickname : driver.driver_name.split(" ")[0],
							label: {
								text: driver.nickname ? driver.nickname : driver.driver_name.split(" ")[0],
								fontWeight: "bold",
								color: status[driver.current_status].color,
								className: "marker-label",
							},
							zIndex: index,
						});

						// Obtém o endereço atual
						//let currentAddress = await this.getCurrentAddress(marker.getPosition());
						
						// Define as informações que aparecerão no popup
						let infowindow = new this.google.maps.InfoWindow({
							content:
								'<div class="popup">' +
									'<h3 class="capitalized">' + driver.driver_name.toLowerCase() + ' (' + driver.nickname.toLowerCase() + ')</h3>' +
									'<h4><b><span style="color: ' + status[driver.current_status].color + '"><i class="fa fa-circle"></i></span> ' + status[driver.current_status].status + '</b></h4>' +
									'<p class="marker"><b><i class="fa fa-fw fa-id-card"></i> Identificação:</b> ' + driver.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-phone fa-rotate-90"></i> Telefone:</b> ' + (driver.phone ? driver.phone.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4") : "Não definido") + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-truck"></i> Veículo' + (driver.current_total_opened == 0 ? ' mais recente' : '') + ':</b> ' + (driver.current_license_plate ? driver.current_license_plate : 'Não definido') + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-boxes"></i> Carga' + (driver.current_total_opened == 0 ? ' mais recente' : '') + ':</b> ' + (driver.current_cargo ? driver.current_cargo : 'Não definida') + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-boxe"></i> Entrega' + (driver.current_total_opened == 0 ? ' mais recente' : '') + ':</b> ' + (driver.current_delivery ? driver.current_delivery : "Não definida") + '</p>' +
									//'<p class="marker"><b>Local atual:</b> ' + currentAddress.formatted_address + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-sync"></i> Última atualização:</b> ' + this.getFormattedDate(driver.updated_at) + '</p>' +
								'</div>',
							pixelOffet: new this.google.maps.Point(0, 0),
						});
						
						// abre o popup ao passar o mouse por cima do marcador
						this.google.maps.event.addListener(marker, "mouseover", function() {
							infowindow.open(this.map, marker);
						});
						
						// Fecha o popup ao retirar o mouse de cima do marcador
						this.google.maps.event.addListener(marker, "mouseout", function() {
							infowindow.close(this.map, marker);
						});
						
						// Abre o modal de informação do motorista
						marker.addListener("click", () => {
							this.openInfo(driver);
						});

						// Adiciona a lista de marcadores
						this.markers.push({
							id: driver.id,
							marker: marker
						});
					}
				} else {
					// Filtra o marcador
					let element = null;
					element = this.markers.filter(element => element.id == driver.id);
					
					// Verifica se foi encotnrado
					if (element.length > 0) {
						let marker = element[0].marker;
						
						// O torna invisível para esse filtro
						marker.setVisible(false);
					}
				}

				// Adiciona a lista de options
				this.driver_options.push(driver);
			});

			// Atualiza Dom
			this.$forceUpdate();
        },

		// Anima a atualização da posiçação do marcador
		animateReposition: function (id, marker, currentPosition, newPosition, duration) {
			let deltalat = (newPosition.lat() - currentPosition.lat()) / 100;
			let deltalng = (newPosition.lng() - currentPosition.lng()) / 100;

			let delay = 10 * duration;
			for (let i = 0; i < 100; i++) {
				setTimeout(() => {
					let lat = marker.position.lat();
					let lng = marker.position.lng();
					lat += deltalat;
					lng += deltalng;
					let latlng = new this.google.maps.LatLng(lat, lng);
					marker.setPosition(latlng);
					// Verifica se a posições atual é diferente
					if ((this.current_driver != null) && (this.current_driver.id == id)) {
						// Verifica se é para seguir o motorista atual
						if (this.follow_current_driver) {
							// Centraliza da posiçao do marcador
							this.map.setCenter(new this.google.maps.LatLng(lat, lng));
						}
					}
				}, delay * i);
			}
		},
		
		/**
		 * Seleciona o motorista e define ele como o atual
		 */
		setMarker: function() {
			// Verifica o motorista selecionado
			if(this.selected_driver == 0) {
				// Reinicia o flag de seguir
				this.follow_current_driver = false;

				// Fecha e limpa o card de informação
				this.closeInfo();
				
				// Centraliza da posiçao inicial
				this.repositonCenterMap();
			} else {
				// Filtra o registro
				let element = null;
				element = this.list.filter(element => element.id == this.selected_driver);
				
				// Se for encontrado
				if (element.length > 0) {
					// Define o marcador
					let driver = element[0];
					
					// Verifica se o motorista em posição registrada
					if (driver.location != null) {
						// Abre o modal de informação
						this.openInfo(driver);
						// Posiciona o mapa
						this.repositonCenterMap(driver);
					} else {
						// Abre o modal de informação
						this.openInfo(driver);
						// Exibe a mensagem
						this.$notification.error("Não foi registrado a posição deste motorista.");
					}
				}
			}
		},

		// Obtém o endereço atual
        getCurrentAddress: async function(latLng) {
            let info = null;

            await this.geocoder.geocode({
                latLng: latLng
            }, function(responses) {
                if (responses && responses.length > 0) {
                    info = {
                        address_components: responses[0].address_components,
                        formatted_address: responses[0].formatted_address,
                    };
                } else {
                    info = {
                        address_components: [],
                        formatted_address: 'Não foi possível determinar o endereço dessa localização',
                    };
                }
            });

            return info;
        },

		// Retorna a data formatada
		getFormattedDate: function(data) {
			let date = new Date(data);
			return date.toLocaleString();
		},
		
		// Reposiciona o mapa
		repositonCenterMap: function(driver = null) {
			// Verifica o objeto
			if (driver) {
				// Define o zoom
				this.map.setZoom(15);

				// Separa as coordenadas
				let coordinates = driver.location.split(",");

				// Centraliza da posiçao do marcador
				this.map.setCenter(new this.google.maps.LatLng(coordinates[0], coordinates[1]));
			} else {
				// Define o zoom
				this.map.setZoom(13);

				// Centraliza da posiçao inicial
				this.map.setCenter(new this.google.maps.LatLng(this.center.lat, this.center.lng));
			}
		},

		verifySwitch: function() {
			if (this.selected_driver == 0) {
				this.follow_current_driver = false;
			}
		},

		openInfo: function(driver) {
			this.current_driver = driver;
			this.show_current_driver_info = true;
		},

		closeInfo: function() {
			this.show_current_driver_info = false;
			this.current_driver = null;
		},

		openMap: function() {
			this.show_current_driver_route_map = true;
		},

		closeMap: function() {
			this.show_current_driver_route_map = false;
		},
	}
}
</script>

<style scoped>
.inner-content {
	position: relative;
	height: calc(100vh - 140px);
	width: 100%;
}

.search {
	position: absolute;
	top: 10px;
	right: 10px;
    width: 275px;
	padding: 15px;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
	z-index: 2;
}

.search label {
	font-weight: bold;
	font-size: 12px;
}

.search select {
	width: 186px;
	margin-left: 5px;
}

.map, .loading {
	width: 100%;
	height: calc(100vh - 140px);
	border-radius: 4px;
	float: left;
	z-index: 1;
}

.loading {
	background-color: #fff;
	color: #ddd;
	font-size: 80px;
    text-align: center;
    line-height: calc(100vh - 95px);
    font-family: Verdana;
}

.map-filter-item {
	position: relative;
	border: none;
	background: #d9d9d9;
	color: #222;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 20px 10px 35px;
	margin-right: 5px;
}

.map-filter-item-all {
	position: relative;
	border: none;
	background: #d9d9d9;
	color: #222;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 20px;
	margin-right: 5px;
}
.map-filter-item-all.active {
	background: #fff;
}

.map-filter-item > img {
	width: 20px;
	height: 20px;
	position: absolute;
	left: 10px;
	top: 6px;
}

.map-filter-item.active {
	background: #fff;
}

.label-switch {
	display: flex;

	/* Rounded border */
	border-radius: 40px;

	/* Size */
	height: 22px;
	width: 44px;

	cursor: pointer;
	transition: all 0.1s linear;
}

.label-switch-off { 
	/* OFF status */
	background-color: #ddd;
	box-shadow: inset 2px 5px 10px rgba(0,0,0,0.3);
	/*-webkit-transition: .4s;
	transition: .4s;*/
	transition: all 0.1s linear;
	border: 1px solid #ddd;
}

.label-switch-on {
	/* ON status */
	background-color: #555;
	
	/* Push the circle to the right */
	justify-content: flex-end;

	/*-webkit-transition: .4s;
	transition: .4s;*/
	transition: all 0.1s linear;
	box-shadow: inset 2px 5px 10px rgba(0,0,0,0.3);
	border: 1px solid #555;
}

.label-switch__input {
	/* Hide the input */
	display: none;
}

.label-switch__circle {
	position: relative;
	top: 1px;

	/* Rounded border */
	border-radius: 100%;

	/* Size */
	width: 18px;
	height: 18px;

	background-color: #fff;
	transition: all 0.1s linear;
}

.label-switch__text {
	position: absolute;
	left: 64px;
	top: 51px;
}

.label-search-div {
	margin-bottom: 10px;
}
</style>